/**
 * Replaces `decamelize`, which pulled in xregexp (~136KB minified) for this one
 * call. Inputs are ASCII API field names, so ASCII classes suffice.
 *
 * Pass 1: acronym followed by a word  (`APIKey`  -> `API_Key`)
 * Pass 2: lowercase/digit followed by a capital (`someKey` -> `some_Key`)
 */
const splitWords = (string) =>
	string
		.replace(/([A-Z\d]+)([A-Z][a-z]+)/g, '$1_$2')
		.replace(/([a-z\d])([A-Z])/g, '$1_$2');

export default function humanizeString(string) {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string');
	}

	string = splitWords(string);
	string = string.toLowerCase().replace(/[_-]+/g, ' ').replace(/\s{2,}/g, ' ').trim();
	string = string.charAt(0).toUpperCase() + string.slice(1);

	return string;
}

export const formatCount = (count) => count?.toLocaleString("en-US");

export const pluralize = (count, singular, plural = `${singular}s`) => `${formatCount(count)} ${count === 1 ? singular : plural}`;
